import * as Types from '../../generated.types'

import { TelephoneFragmentDoc } from '../../fragments/TelephoneFragment_gen'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type OrgAdminsQueryVariables = Types.Exact<{
  orgId: Types.Scalars['Int']
}>

export type OrgAdminsQuery = {
  __typename?: 'Query'
  usersWithRole?: Array<{
    __typename?: 'User'
    id: number
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    birthdate?: string | null
    ssnLast4?: string | null
    tel?: {
      __typename?: 'Telephone'
      nationalNumber: string
      isSmsConfirmed?: boolean | null
      isConfirmationCodeSent?: boolean | null
    } | null
    address?: {
      __typename?: 'AddressDisplay'
      line1?: string | null
      line2?: string | null
      cityName?: string | null
      stateCode?: string | null
      zipcode?: string | null
    } | null
    role: { __typename?: 'Role'; id: number; label?: string | null }
  }> | null
}

export type OrgAdminFragment = {
  __typename?: 'User'
  id: number
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  birthdate?: string | null
  ssnLast4?: string | null
  tel?: {
    __typename?: 'Telephone'
    nationalNumber: string
    isSmsConfirmed?: boolean | null
    isConfirmationCodeSent?: boolean | null
  } | null
  address?: {
    __typename?: 'AddressDisplay'
    line1?: string | null
    line2?: string | null
    cityName?: string | null
    stateCode?: string | null
    zipcode?: string | null
  } | null
  role: { __typename?: 'Role'; id: number; label?: string | null }
}

export const OrgAdminFragmentDoc = `
    fragment OrgAdmin on User {
  id
  firstName
  lastName
  email
  birthdate
  ssnLast4
  tel {
    ...Telephone
  }
  address {
    line1
    line2
    cityName
    stateCode
    zipcode
  }
  role(roleType: OrganizationRole, roleName: business_admin, resourceId: $orgId) {
    id
    label
  }
}
    `
export const OrgAdminsDocument = `
    query OrgAdmins($orgId: Int!) {
  usersWithRole(
    roleName: business_admin
    roleType: OrganizationRole
    resourceId: $orgId
  ) {
    ...OrgAdmin
  }
}
    ${OrgAdminFragmentDoc}
${TelephoneFragmentDoc}`
export const useOrgAdminsQuery = <TData = OrgAdminsQuery, TError = Error>(
  variables: OrgAdminsQueryVariables,
  options?: UseQueryOptions<OrgAdminsQuery, TError, TData>
) =>
  useQuery<OrgAdminsQuery, TError, TData>(
    ['OrgAdmins', variables],
    fetchGql<OrgAdminsQuery, OrgAdminsQueryVariables>(OrgAdminsDocument, variables),
    options
  )

useOrgAdminsQuery.getKey = (variables: OrgAdminsQueryVariables) => ['OrgAdmins', variables]
